<div class="map-popup-header">
    <div class="map-popup-title">
        <rask-header size="4">Alternativ för viapunkt</rask-header>
    </div>
    <div class="buttons">
        <rask-icon-button (click)="close()" icon="fal fa-times">
        </rask-icon-button>
    </div>
</div>

<form [formGroup]="form">
    <div class="d-flex" formArrayName="barighetsklasser">
        @for (bkklass of form.controls.barighetsklasser.controls; track bkklass; let first = $first) {
        <div [formGroup]="bkklass">
            <rask-checkbox
                [label]="first ? 'Bärighetsklasser' : ''"
                [flexResize]="true"
                [text]="bkklass.controls.text.value"
                formControlName="checked">
            </rask-checkbox>
        </div>
        }
    </div>
    <div class="d-flex" formArrayName="vagmotstand">
        @for (vagmotstand of form.controls.vagmotstand.controls; track vagmotstand; let first = $first) {
        <div [formGroup]="vagmotstand">
            <rask-checkbox
                [label]="first ? 'Vägmotstånd' : ''"
                [text]="vagmotstand.controls.text.value"
                formControlName="checked">
            </rask-checkbox>
        </div>
        }
    </div>
</form>


<div class="d-flex">
    <rask-checkbox label="Mottagningsplats" text="Alla"
        (checkedChange)="mottagningsplatsToggle($event)"></rask-checkbox>
</div>
<div class="modal-footer close-btn">
    <rask-button color="secondary" class="footer-button" (click)="close()">Stäng</rask-button>
</div>